module.exports = __webpack_public_path__ + "static/media/CTLI_9-178w.2e0c4eb7.webp";